export const IDENTIFICATION_LINK = 'https://my.cian.ru/identification';
